import React, { useMemo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

type Props<M> = {
  meta: M;
  onChange: (meta: M) => void;
};

export default function MetaFragmentsEditor({
  meta,
  onChange,
}: Props<{ BRONZE: string; SILVER: string; GOLD: string }>) {
  const { BRONZE, SILVER, GOLD } = useMemo(
    () => ({
      BRONZE: meta?.BRONZE,
      SILVER: meta?.SILVER,
      GOLD: meta?.GOLD,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // @ts-ignore
  const handleChangeAmount = (key: string) => (event) => {
    const { value } = event.target;
    if (onChange) {
      onChange({ ...meta, [key]: value });
    }
  };

  const tiers = [
    { key: 'BRONZE' as const, placeholder: BRONZE },
    { key: 'SILVER' as const, placeholder: SILVER },
    { key: 'GOLD' as const, placeholder: GOLD },
  ];

  // One line: label glued to its input, the three tiers side by side
  return (
    <Form.Row>
      {tiers.map(({ key, placeholder }) => (
        <Col md={4} key={key} className="mb-1 mb-md-0">
          <InputGroup size="sm">
            <InputGroup.Prepend>
              <InputGroup.Text>{key}</InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control value={meta?.[key]} placeholder={placeholder} onChange={handleChangeAmount(key)} />
          </InputGroup>
        </Col>
      ))}
    </Form.Row>
  );
}
